<template>
  <div
    class="section-mode-agent"
    :class="switchAdmin.active ? 'active' : 'inactive'"
    style="margin-bottom: 20px"
  >
    <div class="section-mode-agent-header">
      <h6 class="heading-h6 title">Habilitar para administradores</h6>
      <a-switch v-model="switchAdmin.active" @change="handleValueSwitch" />
    </div>
    <p class="body-2 description">
      Recuerda que los administradores deben ser asignados a colas.
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import compareMixin from '@/app/shared/mixins/compare'

export default {
  name: 'SectionModeAdminAgent',
  mixins: [compareMixin],
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.setValue()
  },
  computed: {
    ...mapGetters(['profile']),
    switchAdmin() {
      if (!this.company) return { active: false }
      return { active: this.company.settings.userMode.adminAgent }
    },
  },
  methods: {
    ...mapActions(['updateAdminModeAgent', 'listAgentsAsigned']),
    /**Setea los valores al switch */
    setValue() {
      this.switchAdmin.active = this.company.settings.userMode.adminAgent
    },
    async handleValueSwitch() {
      const self = this
      if (!this.switchAdmin.active) {
        this.$confirm({
          title:
            '¿Estás segur@ de inactivar el modo agente para los administradores?',
          content:
            'Recuerda que todos los tickets abiertos serán transferidos a otro agente de la misma cola.',
          okText: 'Inactivar',
          cancelText: 'Cancelar',
          centered: true,
          async onOk() {
            await self.submitChanges(self.switchAdmin)
          },
          onCancel() {
            self.switchAdmin.active = !self.switchAdmin.active
          },
        })
      } else {
        await self.submitChanges(this.switchAdmin)
      }
    },
    /**
     * Enviar y guardar cambios
     * @param {Object} switchAdmin
     * @param {Boolean} switchAdmin.active
     */
    async submitChanges(switchAdmin) {
      const response = await this.updateAdminModeAgent(switchAdmin)
      if (response.success) {
        this.$message.success('Se guardó correctamente')
        if (this.isAllowedFor(this.profile.type, ['admin']))
          window.location.reload()
        else this.listAgentsAsigned()
      } else return this.$message.error('Ocurrió un error')
    },
  },
}
</script>

<style lang="sass" scoped>
$width-switch: 44px

.section-mode-agent
  border: 1px solid #D9D9D9
  border-radius: 8px
  padding: 12px 20px
  &-header
    display: flex
    flex-direction: row
    justify-content: space-between
    .title
      text-align: left
      color: $gray_dark_800
  .description
    text-align: left
    margin-right: calc( #{$width-switch + 32px} )
    margin-bottom: 0
.active
  color: $gray_dark_800
  .section-mode-agent-header
    .title
      color: $gray_dark_800
.inactive
  color: $gray_dark_700
  .section-mode-agent-header
    .title
      color: $gray_dark_700
</style>
